import { configureStore } from '@sde/widgets-core/src/redux/store';
import { createRootReducer } from '@sde/widgets-core/src/redux/helpers/createRootReducer';
import { reducers } from './modules';

export const configureAppStore = () => {
  const store = configureStore({
    reducer: createRootReducer(reducers),
  });

  if (module.hot) {
    module.hot.accept('./modules', () => {
      store.replaceReducer(createRootReducer(reducers));
    });
  }
  return store;
};
